import { render, staticRenderFns } from "./showText-editor.vue?vue&type=template&id=1d7a1cee&scoped=true&"
import script from "./showText-editor.vue?vue&type=script&lang=js&"
export * from "./showText-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a1cee",
  null
  
)

export default component.exports